import { connect } from 'react-redux';
import ProductConfirmationDialog from './ProductConfirmationDialog';
import { setForceClose } from '../store/createNewSelfAuthorizationSlice';
import {
  fetchSelfAuthorizations,
  fetchUniqueSelectors,
  getCurrentSelection,
  setDialogSelfAuthorization,
  setExtendedLoadingError,
  setProductActivationError,
  setSelfAuthorizationDialogOpen,
  toggleExtendedLoading,
  toggleProductActivation,
} from '../store/selfAuthorizationsSlice';

const mapState = state => ({
  activeSelfAuthTab: state.loadingManagement.selfAuthorizations.activeSelfAuthTab,
  currentSelection: getCurrentSelection(state),
  dialogOpen: state.loadingManagement.selfAuthorizations.selfAuthorizationDialogOpen,
  dialogSelfAuthorization: state.loadingManagement.selfAuthorizations.dialogSelfAuthorization,
});

const mapDispatch = {
  fetchSelfAuthorizations,
  fetchUniqueSelectors,
  setDialogSelfAuthorization,
  setExtendedLoadingError,
  setForceClose,
  setProductActivationError,
  setSelfAuthorizationDialogOpen,
  toggleExtendedLoading,
  toggleProductActivation,
};

export default connect(mapState, mapDispatch)(ProductConfirmationDialog);
